// Shared client/principal enum metadata (labels + ordering) used by the
// Directory pages and the create modals. Kept in one place so the option lists
// and human labels never drift between the list views and the forms.
import type {
  OrganizationStatus,
  OrganizationType,
  PrincipalRiskLevel,
} from '@dsr/shared-types';

export const ORG_TYPES: { value: OrganizationType; label: string }[] = [
  { value: 'corporate', label: 'Corporate' },
  { value: 'hni', label: 'High-Net-Worth Individual' },
  { value: 'government', label: 'Government' },
  { value: 'event', label: 'Event' },
  { value: 'property_mgmt', label: 'Property Management' },
  { value: 'other', label: 'Other' },
];

export const ORG_STATUSES: { value: OrganizationStatus; label: string }[] = [
  { value: 'prospect', label: 'Prospect' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
];

export function typeLabel(t: OrganizationType): string {
  return ORG_TYPES.find((x) => x.value === t)?.label ?? t;
}

export const RISK_LEVELS: PrincipalRiskLevel[] = [
  'low',
  'guarded',
  'elevated',
  'high',
  'severe',
];
